/**
 * PERF_HUB pages: labeled Google Ads Add To Cart (2) + GA4 add_to_cart.
 * Same gtag pair as assets/ild-google-ads-events.js safeGtagAddToCart (lines 113–122).
 * Loaded only on PERF_HUB branch in layout/theme.liquid — not PDP, not funnel/bare.
 */
(function () {
  'use strict';

  var GA4_ID = 'G-XE6CZ5DL31';
  var AW_ATC_CONVERSION = 'AW-870900097/zGb0COu467wcEIHDo58D';

  function priceToDec(cents) {
    return parseFloat(((cents || 0) / 100).toFixed(2));
  }

  function alreadyFired(payload) {
    return payload && (payload.__ildHubGtagAtcFired || payload.__ildGtagAtcFired || payload._gtagFired);
  }

  function markAtcFired(payload) {
    if (!payload || typeof payload !== 'object') return;
    payload.__ildHubGtagAtcFired = true;
  }

  function safeGtagAddToCart(currency, value, items) {
    if (typeof gtag !== 'function') return false;
    gtag('event', 'add_to_cart', {
      send_to: GA4_ID,
      currency: currency,
      value: value,
      items: items,
    });
    gtag('event', 'conversion', {
      send_to: AW_ATC_CONVERSION,
      currency: currency,
      value: value,
    });
    return true;
  }

  function itemFromLine(line) {
    if (!line) return null;
    var productId = line.product_id || line.id;
    if (!productId) return null;
    var price = priceToDec(line.final_price || line.price || 0);
    if (!price && line.presentment_price) price = parseFloat(line.presentment_price);
    return {
      item_id: String(productId),
      id: String(productId),
      item_name: line.title || line.product_title || '',
      item_variant: line.variant_title || '',
      price: price,
      quantity: line.quantity || 1,
      google_business_vertical: 'retail',
    };
  }

  function emitFromPayload(payload, variantId) {
    if (alreadyFired(payload)) return;
    variantId = variantId ? String(variantId) : '';

    var line = null;
    if (payload && payload.items && payload.items.length) {
      if (variantId) {
        line = payload.items.find(function (i) {
          return String(i.variant_id || i.id) === variantId;
        });
      }
      if (!line) line = payload.items[payload.items.length - 1];
    }
    if (!line && payload && (payload.product_id || payload.variant_id || payload.id)) {
      line = payload;
    }

    var item = itemFromLine(line);
    if (!item) {
      fireFromCartJs(variantId, payload);
      return;
    }

    var currency =
      (payload && payload.currency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';
    var value = priceToDec(
      line.final_line_price || line.final_price || line.line_price || line.price || 0
    );
    if (!value) value = item.price * (item.quantity || 1);
    if (safeGtagAddToCart(currency, value, [item])) markAtcFired(payload);
  }

  function fireFromCartJs(variantId, payload) {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (payload && alreadyFired(payload)) return;
        var items = cart.items || [];
        var line = null;
        if (variantId) {
          line = items.find(function (i) {
            return String(i.variant_id) === String(variantId);
          });
        }
        if (!line && items.length) line = items[items.length - 1];
        var item = itemFromLine(line);
        if (!item) return;
        var currency = cart.currency || 'USD';
        var value = priceToDec(line.final_line_price || line.line_price || line.price || 0);
        if (!value) value = item.price * (item.quantity || 1);
        if (safeGtagAddToCart(currency, value, [item]) && payload) markAtcFired(payload);
      })
      .catch(function () {});
  }

  var pendingVariantId = null;
  var pendingTimer = null;

  function clearPending() {
    pendingVariantId = null;
    if (pendingTimer) {
      clearTimeout(pendingTimer);
      pendingTimer = null;
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest(
        '[data-action="atc"], [data-action="sample"], .hero-cta-buy, .hero-cta-sample'
      );
      if (!btn) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      pendingVariantId = variantId;
      if (pendingTimer) clearTimeout(pendingTimer);
      pendingTimer = setTimeout(clearPending, 15000);
    },
    true
  );

  window.addEventListener('cart:updated', function (evt) {
    if (!pendingVariantId) return;
    var variantId = pendingVariantId;
    clearPending();
    emitFromPayload(evt && evt.detail, variantId);
  });

  window.ILHubAtcEvents = {
    fireFromCartResponse: emitFromPayload,
  };
})();
